import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import axiosConfigSSR from '../../apisSetup/axiosConfigSSR';

import miceReducer from '../reducers/miceReducer';


const composeEnhancers = typeof window === 'object' &&
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
	}) : compose;
const combinedReducer = combineReducers({
	mice: miceReducer,
});

export default (initialState = {}, config = {}) => {
	const ccbAxiosApiCaller = axiosConfigSSR(config);
	let store = createStore(combinedReducer, initialState, composeEnhancers(
		applyMiddleware(thunk.withExtraArgument(ccbAxiosApiCaller))
	));
	return { store };
};
